<template>
  <header>
    <div>
      <!-- <div class="navbar-header">
        <a href="/dashboard" class="navbar-brand">
          <img src="../assets/logo.png" class="brand-icon" />
          奥瑞拓全寿命周期管理系统
        </a>
      </div> -->

      <div class="navbar-content">
        <div class="navbar-brand">
          <img src="../../assets/images/logo.png" class="brand-icon" />
          奥瑞拓全寿命周期管理系统
          <div style="margin-left: 30px">
            <!-- <BaseSelect v-model="base_id"></BaseSelect> -->
          </div>
        </div>
      </div>
      <div class="navbar-right">
        <!-- <el-dropdown trigger="click" size="medium">
          <span class="el-dropdown-link">
            <el-badge
              :value="unreadMessageCount"
              :hidden="unreadMessageCount == 0"
              :max="99"
              class="item"
            >
              <i
                class="el-icon-bell"
                style="font-size: 25px; position: relative; top: 2px"
              ></i>
            </el-badge>
          </span>
          <el-dropdown-menu
            class="font-12"
            slot="dropdown"
            style="min-width: 250px"
          >
            <el-dropdown-item
              v-if="unreadMessageCount == 0"
              disabled
              class="text-center"
              >暂无未读消息</el-dropdown-item
            >
            <template v-else>
              <el-dropdown-item v-for="msg in messages" :key="msg.id">
                <router-link :to="msg.link" class="flex-row-between">
                  <div class="msg-content">{{ msg.content }}</div>
                  <div class="font-12 ml-10">
                    {{ timePast(msg.created_at) }}
                  </div>
                </router-link>
              </el-dropdown-item>
            </template>
            <el-dropdown-item divided class="text-center">
              <div
                style="background: #fff; margin: 0 -17px"
                @click="$router.push('/messages')"
              >
                <el-button type="text" size="mini">查看全部消息</el-button>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->

        <ul class="nav navbar-top-links ml-25">
          <li id="dropdown-user" class="dropdown">
            <span
              href="#"
              data-toggle="dropdown"
              class="dropdown-toggle text-right"
              aria-expanded="false"
            >
              <img
                v-if="user.avatar"
                :src="user.avatar"
                class="img-circle img-xs"
              />
              <img
                v-else
                src="../../assets/images/avatar.png"
                class="img-circle img-xs"
              />
              <!-- <i class="ion-person"></i> -->
              <!-- <span class="user-name"> {{ user.name }}</span> -->
            </span>
            <div
              class="dropdown-menu dropdown-menu-sm dropdown-menu-right panel-default"
              style=""
            >
              <ul class="head-list">
                <li>
                  <a href="javascript:;" @click="userSetDialogVisible = true"
                    ><i class="ion-settings"></i> 修改资料</a
                  >
                </li>
                <li>
                  <a @click="handleLogout" class="pointer"
                    ><i class="ion-arrow-left-a"></i> 退出</a
                  >
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="second-nav" v-if="siderbar">
      <div style="display: flex; align-items: center">
        <i class="el-icon-s-fold switch-icon" @click="switchSidebar"></i>
        <el-breadcrumb separator-class="el-icon-arrow-right" class="header">
          <template v-for="nav in navs">
            <el-breadcrumb-item
              v-if="nav.url"
              :to="{ path: nav.url }"
              :key="nav.name"
              >{{ nav.name }}</el-breadcrumb-item
            >
            <el-breadcrumb-item v-else>{{ nav.name }}</el-breadcrumb-item>
          </template>
          <el-breadcrumb-item>{{ $route.meta.name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <!-- <div v-if="showStockroomSelect">
        <el-select @change="choseStockroom" v-model="userStockroomId">
          <el-option
            v-for="(item, index) in stockroomList"
            :key="index"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </div> -->
    </div>

    <UserSet :show.sync="userSetDialogVisible"></UserSet>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
import { constantRoutes } from '@/router/index'
import { menuGroups } from '@/config/navs'
import UserSet from '@/components/user_set'
import BaseSelect from '@/components/select/base_select'
import { messageList } from '@/service/getData'
import { messagesFormat, timePast } from '@/util/index'

const paths = constantRoutes[3].children

export default {
  components: {
    UserSet,
    BaseSelect,
  },
  props: {
    siderbar: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      timePast,
      bases: [],
      base_id: '',
      userSetDialogVisible: false,
      messages: [],
      unreadMessageCount: 0,
      timer: null,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    user() {
      return this.userInfo
    },
    navs() {
      let arr = []
      let route = this.$route
      let fatherPath =
        '/' +
        route.path
          .split('/')
          .splice(1, route.path.split('/').length - 2)
          .join('/')

      let pathArr = paths.filter((item) => item.path == fatherPath)

      outloop: for (let index = 0; index < menuGroups.length; index++) {
        const module = menuGroups[index]

        for (let index = 0; index < module.children.length; index++) {
          const item = module.children[index]

          if (item.module == route.meta.module) {
            arr.push({
              url: '',
              name: module.name,
            })
            break outloop
          }
        }
      }

      if (pathArr.length > 0) {
        let p = pathArr[0]
        arr.push({
          url: p.path,
          name: p.meta.name,
        })
      }
      return arr
    },
  },
  // watch: {
  //   $route(to, from) {
  //     this.requestUnreadMessages()
  //   },
  // },
  // mounted() {
  //   let that = this
  //   this.timer = setInterval(function () {
  //     that.requestUnreadMessages()
  //   }, 1000 * 60)
  // },
  // beforeDestroy() {
  //   if (this.timer) {
  //     clearInterval(this.timer)
  //   }
  // },
  // created() {
  //   this.requestUnreadMessages()
  // },
  methods: {
    async requestUnreadMessages() {
      let res = await messageList({ status: 1, limit: 5 })
      if (res.code == 0) {
        this.messages = messagesFormat(res.data.list)
        this.unreadMessageCount = res.data.count
      }
    },
    async handleLogout() {
      this.$store.commit('logout')
      this.$router.push('/')
    },
    switchSidebar() {
      this.$store.commit('switch_sidebar')
    },
  },
}
</script>

<style scoped>
.msg-content {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 10px;
}
.second-nav {
  background: #326de6;
  height: 56px;
  line-height: 56px;
  color: #fff;
  padding: 0 20px;
  padding-right: 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.second-nav a {
  color: #fff;
}

.switch-icon {
  font-size: 24px;
  opacity: 1;
  margin-right: 20px;
}
</style>

<style>
.header .el-breadcrumb__inner {
  color: #fff !important;
  font-size: 18px;
  font-weight: 500 !important;
  opacity: 0.6;
}

.header .el-breadcrumb__inner a,
.header .el-breadcrumb__inner.is-link {
  color: #fff;
}

.header .el-breadcrumb__inner.is-link:hover {
  color: #fff;
}

.header .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.header .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.header .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.header .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  opacity: 1;
}
</style>